export const PRODUCT_FEATURE_CAPABILITY = {
  REMOVE_BRANDING: "remove_branding"
};

const ENABLED = "enabled";
const DISABLED = "disabled";
export const FLAG_STATUS = {
  ENABLED,
  DISABLED
};
